import {
  initialState,
  Actions,
  State,
  GET_COMMENTS_FACTURACION,
  GET_COMMENTS_FACTURACION_SUCCESS,
  GET_COMMENTS_FACTURACION_ERROR,
  RESET_GET_COMMENTS_FACTURACION,
} from "../../types/facturacion/getComments";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_COMMENTS_FACTURACION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_COMMENTS_FACTURACION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_COMMENTS_FACTURACION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_COMMENTS_FACTURACION:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
